const DATE_END_INDEX = 10;

// returned date: yyyy-MM-dd (ex: 2021-09-20)
export const getCurrentDate = () => new Date()
  .toISOString()
  .slice(0, DATE_END_INDEX);

// returned date: yyyy-MM-dd (ex: 2021-09-01)
export const getFirstDayOfTheMonthDate = () => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1)
    .toISOString()
    .slice(0, DATE_END_INDEX);
};

// returned date: 20/09/2021 às 15:21:53
export const getCurrentFormattedLocaleStringDate = () =>
  ` ${new Date().toLocaleDateString()} às ${new Date().toLocaleTimeString()}`;
